'use client'

import { useState } from 'react'
import { logError } from '@gforce/shared-errors'
import { Button } from '@/components/ui/button'

interface GoogleSignInButtonProps {
  /** Google 認証が有効か（サーバーで鍵の有無を見て決める・lib/auth/google-sign-in.ts） */
  enabled: boolean
  /** ログイン後の行き先（use-login-form の nextPath と同じもの） */
  nextPath: string
  /** Google へのサインインを始める（本番は authClient.signIn.social） */
  startGoogleSignIn: (nextPath: string) => Promise<void>
}

/**
 * 社員の Google 認証のボタン（ADR-049）。社のドメインのアカウントだけ・既存の社員だけが入れる（判定はサーバー）。
 * 無効なら何も出さない。
 */
export function GoogleSignInButton({
  enabled,
  nextPath,
  startGoogleSignIn,
}: GoogleSignInButtonProps) {
  const [isStarting, setIsStarting] = useState(false)
  const [failed, setFailed] = useState(false)
  if (!enabled) return null

  const handleClick = async () => {
    setFailed(false)
    setIsStarting(true)
    try {
      await startGoogleSignIn(nextPath)
    } catch (err) {
      logError(err, 'login: Google sign-in could not start')
      setFailed(true)
      setIsStarting(false)
    }
  }

  return (
    <div className="space-y-2">
      <Button
        type="button"
        variant="outline"
        className="w-full h-12 rounded-xl"
        disabled={isStarting}
        onClick={handleClick}
      >
        Google でログイン
      </Button>
      {failed && (
        <p role="alert" className="text-sm text-destructive">
          Google でのログインを始められませんでした。時間をおいてもう一度お試しください。
        </p>
      )}
    </div>
  )
}
